import { Button, Col, Empty, Pagination, Row, Skeleton, Space, Table, Input, message, Popconfirm } from 'antd';
import React, { useEffect, useState } from 'react'
import { axionsInstanceBaseApi } from '../components/network';
import { Link } from 'react-router-dom';
import type { PopconfirmProps } from 'antd';
const { Search } = Input;

interface DataProps {
  list: any[],
  totalCount: number
}

const InitalData: DataProps = {
  list: [],
  totalCount: 0
}

type FilterType = {
  page?: number
  max?: number
  search?: string
}

const GroupList = () => {

  const [data, setData] = useState(InitalData)
  const [loading, setLoading] = useState(false)
  const [filter, _setFilter] = useState<FilterType>({
    page: 1,
    max: 10,
    search: '',
  })


  const _token = localStorage.getItem('imToken')

  const setFilter = (value: Partial<FilterType>) => {

    _setFilter({ ...filter, ...value })
  }

  const fetchGroupList = async (token: string) => {
    setLoading(true)
    try {
      const response = await axionsInstanceBaseApi.post('/group/get_groups',
        {
          current: filter.page,
          groupID: '',
          pageSize: 10,
          pagination: { pageNumber: filter.page, showNumber: 10 }
        }, {
        headers: { 'Content-Type': 'application/json', 'Token': token },
      })
      setData({ ...data, list: response?.data?.data?.groups, totalCount: response?.data?.data?.total })
      setLoading(false)
    } catch (e) {
      setLoading(false)
      console.log('ERROR:::::::::', e)
    }
  }


  useEffect(() => {

    if (_token) {
      fetchGroupList(_token)
    }
  }, [filter])

  const dataSource = data?.list || []

  const convertTimestampToDate = (timestamp: string) => {

    const timestampNumber = typeof timestamp === 'string' ? parseInt(timestamp, 10) : timestamp;
    const date = new Date(timestampNumber);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}_${month}_${day}`;
  }

  const handleDeleteGroup = async (id: string) => {
    try {
      await axionsInstanceBaseApi.post('/group/dismiss_group', { groupID: id }, {
        headers: { 'Content-Type': 'application/json', 'Token': _token },
      })
      message.success('Амжилттай устлаа')
      if (_token) {
        fetchGroupList(_token)
      }

    } catch (e: any) {
      console.log('ERROR_DELETE_GROUP_CHAT', e.message)
      message.error('Алдаа гарлаа', e)
    }
  }

  const cancel: PopconfirmProps['onCancel'] = () => {
    message.error('Болих');
  };
  const columns = [

    {
      title: '№',
      width: 80,
      dataIndex: 'index',
      key: 'index',
      render: (text: any, record: any, index: number) => {
        return (<>{index + 1}</>)
      }
    },

    {
      title: 'Зураг',
      dataIndex: 'groupInfo',
      key: 'faceURL',
      render: (groupInfo: any) => {
        return (
          <React.Fragment>
            <img className='h-11 w-11 object-cover rounded-md outline-none border-none bg-gray-200' alt='faceUrl' src={groupInfo.faceURL ? groupInfo.faceURL : './defaultImage.png'} />
          </React.Fragment>
        )
      }
    },
    {
      title: 'Грөүп эзэмшигч ID',
      dataIndex: 'groupOwnerUserID',
      key: 'groupOwnerUserID',
    },
    {
      title: 'Групп нэр',
      dataIndex: 'groupInfo',
      key: 'groupInfo',
      render: (groupInfo: any) => {
        return (
          <React.Fragment>
            <div>{groupInfo.groupName}</div>
          </React.Fragment>
        )
      }
    },
    {
      title: 'Грөүпийн төрөл',
      dataIndex: 'groupInfo',
      key: 'groupType',
      render: (groupInfo: any) => {
        return (
          <React.Fragment>
            <div>{groupInfo.groupType}</div>
          </React.Fragment>
        )
      }
    },
    {
      title: 'Гишүүдийн тоо',
      dataIndex: 'groupInfo',
      key: 'memberCount',
      render: (groupInfo: any) => {
        return (
          <React.Fragment>
            {groupInfo?.memberCount}
          </React.Fragment>
        )
      }
    },
    {
      title: 'Грөүп ID',
      dataIndex: 'groupInfo',
      key: 'groupID',
      render: (groupInfo: any) => {
        return (
          <React.Fragment>
            {groupInfo?.groupID}
          </React.Fragment>
        )
      }
    },
    {
      title: 'Үүсгэсэн огноо',
      dataIndex: 'groupInfo',
      key: 'createTime',
      render: (groupInfo: any) => {
        const formattedDate = convertTimestampToDate(groupInfo?.createTime);
        return (
          <React.Fragment>
            {formattedDate}
          </React.Fragment>
        )
      }
    },
    {
      title: 'Үйлдэл',
      key: 'action',
      render: (item: any) => {
        const groupId = item?.groupInfo.groupID

        return (
          <>
            <Space>
              <Button style={{ color: 'blue' }} type="primary" className='!text-white'>
                <Link to={`/groupList/${groupId}/groupMember`}> Гишүүд</Link>
              </Button>
              <Popconfirm
                title="Устгах"
                description="Энэ үйлдлийг хийхдээ итгэлтэй байна уу ?"
                onConfirm={() => handleDeleteGroup(groupId)}
                onCancel={cancel}
                okText="Yes"
                cancelText="No"
              >
                <Button style={{ color: 'blue' }} type="primary" className='!text-white'>
                  Устгах
                </Button>
              </Popconfirm>

            </Space>
          </>
        )
      },
    },

  ];



  const onPageChange = (page: number) => {

    setFilter({ page })
  }

  const onShowSizeChange = (current: any, pageSize: any) => {
    setFilter({ max: pageSize })
  }
  const showTotal = (total: number, range: number[]) => {
    return (
      <>
        Нийт: <span>{total}</span>
      </>
    )
  }

  const onSearchMember = () => {
    console.log('onsearchg')
  }

  return (
    <div>
      <Row className='mb-6'>
        <Col span={4}>
          <Search placeholder="Нэрээр хайх" onSearch={onSearchMember} enterButton />
        </Col>
      </Row>
      <Table
        dataSource={dataSource}
        columns={columns}
        locale={{
          emptyText: loading ? <Skeleton active={true} /> : <Empty />,
        }}
        pagination={false}
      />
      <div className='flex items-center justify-end my-4'>
        <Pagination
          pageSize={filter.max}
          total={data?.totalCount}
          current={filter.page}
          onChange={onPageChange}
          showSizeChanger
          onShowSizeChange={onShowSizeChange}
          showTotal={showTotal}
        />
      </div>
    </div>
  )
}

export default GroupList